import React from 'react';
import { Link } from 'react-router-dom';
import { useThemeManager } from '../Hooks/ThemeManager';
import { TbFaceIdError } from 'react-icons/tb';

const NotFound = () => {
  const { themeColors } = useThemeManager();

  return (
    <div className="container d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
      <TbFaceIdError 
        size={200} 
        color="var(--secondary-color)"
        style={{ marginBottom: '10px' }}
      />
      <h1 className="color-secondary" style={{ fontSize: '80px', margin: '0' }}>404</h1>
      <h3 className="color-secondary" style={{ marginBottom: '15px' }}>Página no encontrada</h3>
      <p className="text-muted text-center mb-4" style={{ maxWidth: '500px' }}>
        Lo sentimos, la página que estás buscando no existe o ha sido movida.
      </p>
      <Link 
        to="/home" 
        className="btn btn-primary"
        style={{ 
          backgroundColor: 'var(--secondary-color)', 
          borderColor: 'var(--secondary-color)',
          padding: '10px 30px',
          borderRadius: '25px',
          fontWeight: '500'
        }}
      >
        Ir al inicio
      </Link>
    </div>
  );
};

export default NotFound;